module.exports = new __parcel__URL__("73091265.18be801a.png").toString();